import { useEffect, useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import "./styles.module.css";
import styles from "./styles.module.css";
import Modal from "../../../app/common/modals/Custom";
import { useNavigate } from "react-router-dom";
import AllTickets from "./lists/AllTickets";
import { FilterModal } from "../../../app/common/helpers";
import { ReactComponent as SvgSearchIcon } from "../../../assets/searchIcon.svg";
import { ReactComponent as ThumbsUpSvg } from "../../../assets/navbericon/thumbsup.svg";
import { ReactComponent as PlusCircle } from "../../../assets/plusCircle.svg";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import TablePlaceholder from "../products/tables/TablePlaceholder";

const TicketsIndex = () => {
  const [currentFilter, setCurrentFilter] = useState({ value: "", code: 0 });
  const [modal, setModal] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const { ticketStore } = useStore();
  const {
    loadingInitial,
    getVendorTickets,
    vendorTicketItemList,
    vendorUnresolvedTicketItemList,
    vendorResolvedTicketItemList,
  } = ticketStore;

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement>, 
  ) => {
    // setCurrentPage(1); // Reset the page to 1
    setSearchTerm(e.target.value); // Update the search term
    if(e.target.value){
      getVendorTickets(searchTerm);
    }else {
      getVendorTickets("");
    }
  };
  const filteredTicketItemList = vendorTicketItemList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.title != null &&
        val.title.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return val;
      } else {
        return null;
      }
    })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.status === "Active";
      } else if (currentFilter.code === 3) {
        return fil.status !== "Active";
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        return 1;
      } else if (currentFilter.value === "Oldest to Newest") {
        return -1;
      } else {
        return 0;
      }
      // return a === b ? 0 : a > b ? 1 : -1;
    });

  const filteredUnresolvedTicketItemList = vendorUnresolvedTicketItemList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else {
    //     getVendorTickets(searchTerm);
    //   } 
    // })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.status === "Active";
      } else if (currentFilter.code === 3) {
        return fil.status !== "Active";
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        return 1;
      } else if (currentFilter.value === "Oldest to Newest") {
        return -1;
      } else {
        return 0;
      }
      // return a === b ? 0 : a > b ? 1 : -1;
    });

  const filteredResolvedTicketItemList = vendorResolvedTicketItemList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.title != null &&
    //     val.title.toLowerCase().includes(searchTerm.toLowerCase())
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return fil.status === "Active";
      } else if (currentFilter.code === 3) {
        return fil.status !== "Active";
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        return 1;
      } else if (currentFilter.value === "Oldest to Newest") {
        return -1;
      } else {
        return 0;
      }
      // return a === b ? 0 : a > b ? 1 : -1;
    });
  const panes = [
    {
      menuItem: "All Tickets",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllTickets ticketList={filteredTicketItemList} />
        ),
    },
    {
      menuItem: "Resolved",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllTickets ticketList={filteredResolvedTicketItemList} />
        ),
    },
    {
      menuItem: "Unresolved",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllTickets ticketList={filteredUnresolvedTicketItemList} />
        ),
    },
  ];
  const statuses = [{ name: "successful", code: 0 }];
  useEffect(() => {
    getVendorTickets(searchTerm || "");
  }, [getVendorTickets]);

  return (
    <div className={styles.page}>
      {loadingInitial === "loading" && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("1")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Ticket Sent successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.activate}
                onClick={() => setModal("1")}
              >
                <div className={styles.button}>
                  <span>Okay</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <div className={styles.header}>
        Tickets
        <div className={styles.searchAndFilter}>
          <div>
            <div className={`${styles.hassearch}`}>
              {/* <span className="fa fa-search form-control-feedback"></span> */}
              <SvgSearchIcon className={styles.formcontrolfeedback} />
              <input
                type="text"
                className={styles.formcontrol}
                placeholder="Search Tickets"
                onChange={(e) => {
                  handleSearchChange(e)
                }}
              />
            </div>
          </div>
          <FilterModal
            // selected={currentFilter.value}
            options={[...statuses]
              .sort(function (x, y) {
                let a = x.name.toUpperCase(),
                  b = y.name.toUpperCase();
                return a === b ? 0 : a > b ? 1 : -1;
              })
              .map((status, index) => ({
                code: index + 1,
                value: status.name,
              }))}
            onSelect={(e) => setCurrentFilter({ value: e.value, code: e.code })}
          />
          <Button
            positive
            className={styles.activate}
            onClick={() => navigate("/vendor/tickets/new-ticket")}
          >
            <div className={styles.positive}>
              <span>New Ticket</span>
              <PlusCircle />
            </div>
          </Button>
        </div>
      </div>

      <div className={styles.tableSection}>
        <div className="section">
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default observer(TicketsIndex);
